import './index.scss';
import user from '../../objects/user/model';
import { Toast } from 'antd-mobile';

const Complain = () => {
  return (
    <div className="complain-container">
      <div className="textbox">
        <span className="icon"></span>
        <h2 style={{ fontWeight: 'bold' }}>投诉已提交</h2>
        <p>
          微信团队会尽快核实，并通过"微信团队“通知你审核结果。感谢你的支持。
        </p>
      </div>
      <div className="footer">
        <a>
          <button
            onClick={async () => {
              await user.banUser();
              window.location.href = '/';
            }}
            type="button"
            id="submit"
          >
            关闭
          </button>
        </a>
      </div>
    </div>
  );
};
export default Complain;
